import React, {createContext} from 'react';
import PropTypes from 'prop-types';
import useModal from '../hooks/useModal';
import Modal from '../components/Modal';

export const ModalContext = createContext();
const {Provider} = ModalContext;

export const ModalProvider = ({children = null}) => {
  const {visible, toggleModal, content, props} = useModal();
  return (
    <Provider value={{visible, toggleModal, content, props}}>
      {visible && (
        <Modal
          {...props}
          onClose={() => {
            toggleModal({isVisible: false});
            // eslint-disable-next-line react/prop-types
            if (props.onClose) props.onClose();
          }}>
          {content}
        </Modal>
      )}
      {children}
    </Provider>
  );
};

ModalProvider.propTypes = {
  children: PropTypes.node,
};

export default {Consumer: ModalContext.Consumer, Provider: ModalProvider};
